<template>
<div class="chapter">
<div class="inner_page">
<div style="display:none;"><a id="GBS.PP1"></a><a id="GBS.PP1.w.0.0.0"></a><a id="GBS.PP1.w.1.0.0"></a><a id="GBS.PP1.w.2.0.0"></a><a id="GBS.PP1.w.3.0.0"></a><a id="GBS.PT1"></a><a id="GBS.PT1.w.0.0.0"></a><a id="GBS.PT2"></a><a id="GBS.PT2.w.0.0.0"></a><a id="GBS.PT2.w.1.0.0"></a><a id="GBS.PT2.w.2.0.0"></a><a id="GBS.PT3"></a><a id="GBS.PT3.w.0.0.0"></a><a id="GBS.PT4"></a><a id="GBS.PT4.w.0.0.0"></a><a id="GBS.PT4.w.1.0.0"></a><a id="GBS.PT4.w.1.1.0"></a><a id="GBS.PT4.w.2.0.0"></a><a id="GBS.PT4.w.2.1.0"></a><a id="GBS.PT4.w.3.0.0"></a><a id="GBS.PT4.w.4.0.0"></a><a id="GBS.PT4.w.5.0.0"></a><a id="GBS.PT4.w.6.0.0"></a><a id="GBS.PT4.w.7.0.0"></a><a id="GBS.PT5"></a><a id="GBS.PT5.w.0.0.0"></a><a id="GBS.PT5.w.1.0.0"></a><a id="GBS.PT5.w.1.1.0"></a><a id="GBS.PT5.w.1.2.0"></a><a id="GBS.PT5.w.2.0.0"></a><a id="GBS.PT5.w.3.0.0"></a><a id="GBS.PT5.w.3.1.0"></a><a id="GBS.PT5.w.3.2.0"></a><a id="GBS.PT5.w.3.3.0"></a><a id="GBS.PT5.w.4.0.0"></a><a id="GBS.PT5.w.5.0.0"></a><a id="GBS.PT5.w.5.1.0"></a></div><div style="display:none;"><a id="GBS.PT6"></a><a id="GBS.PT6.w.0.0.0"></a></div>
<div style="display:none;"><a id="GBS.PT6.w.0.0.0.1"></a></div><div style="display:none;"><a id="GBS.PT6.w.0.0.0.2"></a></div><div class="flow" style="">
<a class="page full_page_image" id="ORIG-GBS.PP1"></a>
<a id="GBS.PT6.w.0.0.0.3"></a><a id="GBS.PT6.w.0.0.0.4"></a></div>
<div class="flow" style="">
<a class="page full_page_skipped" id="ORIG-GBS.PT1"></a>
</div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PT2"></a>
<a id="GBS.PT6.w.0.0.0.5"></a><img alt="Image for page 2" src="data/content-0002.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PT6.w.0.0.0.6"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PT3"></a>
<a id="GBS.PT6.w.0.0.0.7"></a><img alt="Image for page 3" src="data/content-0003.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PT6.w.0.0.0.8"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PT4"></a>
<a id="GBS.PT6.w.0.0.0.9"></a><img alt="Image for page 4" src="data/content-0004.jpg" style="max-width:100%; max-height:100%"/><a id="GBS.PT6.w.0.0.0.10"></a></div>
<div class="flow" style="">
<div class="pagebreak"></div>
<a class="page full_page_image" id="ORIG-GBS.PT5"></a>
<a id="GBS.PT6.w.0.0.0.11"></a><img alt="Image for page 5" src="data/content-0005.png" style="max-width:100%; max-height:100%"/><a id="GBS.PT6.w.0.0.0.12"></a></div>
<div style="display:none;"><a id="GBS.PT6.w.0.0.0.13"></a></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content0006.vue?033bf330